// components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children, allowRoles = [] }) {
  const { loading, user, profile, subscriptionAccess } = useAuth();
  if (loading) return null;
  const isLoggedIn = !!user;
  const role = profile?.role;

  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (subscriptionAccess?.requirePayment) return <Navigate to="/subscription" replace />;

  // allowRoles 지정이 있고, 현재 role이 포함되지 않으면 막기
  if (allowRoles.length > 0 && !allowRoles.includes(role)) {
    return <Navigate to="/reservation-search" replace />;
  }

  return children;
}
